import { Injectable } from '@angular/core';
import { waitSeconds } from '@reflact/tsutil';
import { UsertokenService } from '@shared-angular/services/usertoken.service';
import { connectSocket } from '@shared-angular/utils/socket-client.util';
import type { Socket } from 'socket.io-client';

@Injectable({
    providedIn: 'root'
})
export class DebugSocketService {
    private debugSocket?: Socket;
    private currentBotId?: string;

    constructor(private usertokenService: UsertokenService) { }

    public connectToDebug(botid: string) {
        // Recreate socket when botId changes — the server context (room) is
        // fixed to the connection-time botId and cannot be switched mid-session.
        if (this.debugSocket != null && this.currentBotId === botid) {
            return;
        }
        if (this.debugSocket != null) {
            this.debugSocket.disconnect();
            this.debugSocket = undefined;
        }
        this.currentBotId = botid;
        this.debugSocket = connectSocket({
            namespace: '/debug',
            auth: () => ({ ut: "" + this.usertokenService.getUserToken(), botid })
        });
    }

    public async getDebugIo(): Promise<Socket> {
        if (this.debugSocket) {
            return this.debugSocket;
        }
        await waitSeconds(1);
        return this.getDebugIo();
    }
}
